export const storageKeys = {
  OPEN_MENU_KEYS: 'openMenuKeys',
  SELECTED_MENU_KEYS: 'selectedKeys',
  BREAD_KEYS: 'breadKeys',
  USERINFO: 'userInfo',
  TOKEN: 'token',
  COLLAPSED: 'collapsed',
  LAST_VISIT_PATH: 'lastVisitPath',
};
